import { SplitTestsState, Variant } from '../../../tabs/CampaignWorkflowTab/state/SplitTests/SplitTestsState';
import { formatTime } from '../utils/datetime';

export interface SplitTestsMapperModel {
  onsiteMessageSegments?: {
    segmentId: string;
    splitTestData?: {
      id: string;
      name: string;
      splitTestEnabled: boolean;
      startDate: number;
      endDate?: number;
    };
    controlGroupEnabled: boolean;
    controlGroupWeight: number;
    variants: {
      id: string;
      weight: number;
      name?: string;
      isDefault: boolean;
    }[];
  }[];
}

export class SplitTestsMapper {
  public static Map(response: SplitTestsMapperModel): SplitTestsState {
    const splitTests = response.onsiteMessageSegments?.filter(s => s.splitTestData?.splitTestEnabled);
    if (!splitTests?.length) {
      return {};
    }

    return splitTests.reduce<SplitTestsState>((prev, curr) => {
      const startDate = curr.splitTestData.startDate ? new Date(curr.splitTestData.startDate) : new Date();
      const endDate = curr.splitTestData.endDate ? new Date(curr.splitTestData.endDate) : undefined;

      return {
        ...prev,
        [curr.segmentId]: {
          id: curr.segmentId,
          splitTestId: curr.splitTestData.id,
          name: curr.splitTestData.name,
          controlGroupEnabled: curr.controlGroupEnabled,
          controlGroupWeight: curr.controlGroupWeight,
          scheduling: {
            startDate: startDate,
            startTime: curr.splitTestData.startDate
              ? `${formatTime(startDate.getHours())}:${formatTime(startDate.getMinutes())}`
              : '00:00',
            endDate: endDate,
            endTime: endDate ? `${formatTime(endDate.getHours())}:${formatTime(endDate.getMinutes())}` : undefined,
          },
          variants: curr.variants.map<Variant>(s => ({
            messageId: s.id,
            name: s.name,
            weight: s.weight,
            isDefault: s.isDefault,
          })),
        },
      };
    }, {});
  }
}
